import {AnyAction} from 'redux';
import {LiveReducer as State} from '../../@types/reducers';
import {
    BOOK_EVENT_SUCCESS,
    DELETE_ALERT_SUCCESS,
    DELETE_LIVE_SETTINGS_SUCCESS,
    EDIT_LIVE_EVENT,
    GET_EVENT_SUCCESS,
    GET_LIVE_EVENTS,
    GET_LIVE_EVENTS_SUCCESS,
    GET_LIVE_SETTINGS_SUCCESS,
    HIDE_ALERT_SUCCESS,
    LIVE_INITIALIZE_SUCCESS,
    NEW_BOOKED_EVENT,
    NEW_HIDDEN_ALERT,
    SET_ORDER,
    SET_SETTINGS,
    STORE_LIVE_INITIALIZE,
} from "../../constants/LiveConstants";
import {buildSettings, processEvent} from "../utils/liveUtils";
import {GET_BOOKS_SUCCESS} from "../../constants/UserConstants";
import {AlertLiveObject, EventsStoredObjects, LiveProcessingEvent} from '../../@types/response';
import {eventToStore} from '../utils/events';

const initialState: State = {
    initializing: true,
    event: undefined,
    events: {},
    alerts: [],
    booked: [],
    hides: {},
    books: [],
    template: null,
    templates: [],
    settings: {
        bookmakers: [],
        comparisons: {},
        date: 0,
        from: 1,
        to: 1,
        order: 3,
        onlyDrop: false,
        playability: 0,
    }
};

const liveReducer = (state = initialState, action: AnyAction): State => {
    switch (action.type) {
        case SET_SETTINGS: {
            const {sports: _sports, ...payload} = action.payload || {}
            const settings = Object.assign({}, state.settings, payload)
            return {
                ...state,
                settings: settings,
            }
        }
        case STORE_LIVE_INITIALIZE: {
            if (state.templates.includes(action.payload.name))
                return state
            return {
                ...state,
                templates: [...state.templates, action.payload.name]
            }
        }
        case LIVE_INITIALIZE_SUCCESS: {
            const {sports: _sports, ...serverSettings} = buildSettings(action.payload.settings)
            const settings = Object.assign({}, state.settings, serverSettings)
            return {
                ...state,
                initializing: false,
                booked: action.payload.booked,
                hides: action.payload.hides,
                settings: settings,
                books: action.payload.books,
                templates: action.payload.templates,
            };
        }
        case GET_LIVE_SETTINGS_SUCCESS: {
            const {sports: _sports, ...serverSettings} = action.payload.settings || {}
            return {
                ...state,
                initializing: false,
                settings: Object.assign({}, state.settings, serverSettings),
                template: action.payload.template
            };
        }
        case DELETE_LIVE_SETTINGS_SUCCESS: {
            return {
                ...state,
                templates: state.templates.filter((item: string) => item !== action.payload.template)
            };
        }
        case GET_LIVE_EVENTS: {
            return {
                ...state,
                initializing: true
            }
        }
        case GET_LIVE_EVENTS_SUCCESS: {
            const events: EventsStoredObjects = action.payload
                .reduce((obj: any, item: any) => Object.assign(obj, {[item._id]: eventToStore(item)}), {});
            const alerts: AlertLiveObject[] = action.payload.map((e: LiveProcessingEvent) => processEvent(e, state.settings, state.booked, state.hides)).flat()
            return {
                ...state,
                events: events,
                alerts,
                initializing: false
            };
        }
        case EDIT_LIVE_EVENT: {
            const _events = Object.assign({}, state.events, {[action.payload.event._id]: eventToStore(action.payload.event)})
            const _newAlerts: AlertLiveObject[] = processEvent(action.payload.event, state.settings, state.booked, state.hides)
            const _rmAlerts = state.alerts.filter(_m => _m.id !== action.payload.event._id)
            let _alerts = !_newAlerts.length && state.alerts.length === _rmAlerts.length ? state.alerts :
                _rmAlerts.concat(_newAlerts)
            return {
                ...state,
                events: _events,
                alerts: _alerts
            };
        }
        case SET_ORDER: {
            return {
                ...state,
                settings: Object.assign({}, state.settings, {order: action.payload})
            };
        }
        case GET_EVENT_SUCCESS: {
            return {
                ...state,
                event: action.payload
            };
        }
        case GET_BOOKS_SUCCESS: {
            return {
                ...state,
                books: action.payload
            };
        }
        case BOOK_EVENT_SUCCESS:
        case NEW_BOOKED_EVENT: {
            const booked = [...state.booked, action.payload]
            return {
                ...state,
                booked: booked,
                alerts: state.alerts.filter(alert => action.payload !== (alert.sbv ? `${alert.id}-${alert.marketId}@${alert.sbv}-${alert.signId}` : `${alert.id}-${alert.marketId}-${alert.signId}`))
            };
        }
        case DELETE_ALERT_SUCCESS: {
            return {
                ...state,
                alerts: state.alerts
                    .filter(alert => {
                        return !(alert.id === action.payload.eventId
                            && alert.marketId === action.payload.marketId
                            && (action.payload.sbv === undefined || alert.sbv === action.payload.sbv))
                    })
            }
        }
        case HIDE_ALERT_SUCCESS:
        case NEW_HIDDEN_ALERT: {
            const hides = Object.assign({}, state.hides, action.payload)
            return {
                ...state,
                hides: hides,
                alerts: state.alerts.filter(alert => action.payload !== (alert.sbv ? `${alert.id}-${alert.marketId}@${alert.sbv}-${alert.signId}` : `${alert.id}-${alert.marketId}-${alert.signId}`))
            };
        }
        default:
            return state;
    }
};

export default liveReducer;
